// Identidad del SDK que viaja en `sdk { name, version }` (la versión la fija package.json).
export const SDK_NAME = '@knowyourparcel/web';
export const SDK_VERSION = '0.1.0';
